import { render, staticRenderFns } from "./AppStandardCropper.vue?vue&type=template&id=53938f75&"
import script from "./AppStandardCropper.vue?vue&type=script&lang=js&"
export * from "./AppStandardCropper.vue?vue&type=script&lang=js&"
import style0 from "./AppStandardCropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports